module.exports = __webpack_public_path__ + "static/media/ShareGray.5d79d0e3.svg";